import { WorkItemBase } from './workitem-base-model';
import { GenesysChatWorkItem } from '../interfaces/genesys-chat-item.interface';
import { WorkItemTypes } from '../constants/workitem-types';

export class WorkItemGenesysChat extends WorkItemBase implements GenesysChatWorkItem {
  readonly type: string = WorkItemTypes.GENESYS_CHAT;
  isClosable = true;
  protected readonly _isCollapsible = true;
  keepAlive = true;

  constructor(id: string) {
    super({ id });
  }
}
